export default [
  { naoNulo: true, tipo: 'string', atributo: 'nome', nome: 'Nome' },
  { naoNulo: true, tipo: 'string', atributo: 'referencia', nome: 'Referência' },
  { naoNulo: true, tipo: 'string', atributo: 'numero', nome: 'Número' },
  { tipo: 'string', atributo: 'dataConclusao', nome: 'Data de Conclusão' },
  { naoNulo: true, tipo: 'numero', atributo: 'preco', nome: 'Preço' },
  { naoNulo: true, tipo: 'numero', atributo: 'quantidade', nome: 'Quantidade' },
];
